<template>
  <div>
    <header-block title="Track your spend" :transparent="true" ></header-block>
    <div class="imageContainer">
      <div class="textContainer">
        <h2 class="title">Make every penny count</h2>
        <p class="paragraph">
          We'll help you keep track of your spend so you always know how much is left to use - and when it's time to top up.
        </p>
        <div class="anchor-bottom">
          <MGButton text="Close" @click="$router.go(-1)"></MGButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';

export default {
  name: 'TrackYourSpendPage',
  components: {
    HeaderBlock, MGButton
  }
};
</script>

<style scoped>

.paragraph {
  font-size: 13px;
  line-height: 24px;
  margin-bottom: 16px;
}
.imageContainer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-image: url('~@/assets/bg/TrackSpend.png');
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  overflow: hidden;
  z-index: 0;
}

.textContainer {
  margin-top:50px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  z-index: 2;
  padding: 40px 20px;
}

.paymentMethods {
  position: relative;
  width: 200px;
  margin: 20px auto 0 auto;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 16px;
}

.footerText {
  padding: 40px 20px;
  text-align: center;
}

.footerText p {
  font-size: 11px;
}

.circle {
  background-color: white;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin-bottom: 10px;
  font-size: 24px;
  font-weight: bold;
}
</style>
